module.exports = __webpack_public_path__ + "static/media/CitrusStage2.bf0cbccd.PNG";